module.exports = {"610927100":"城关镇","610927101":"曾家镇","610927102":"牛头店镇","610927103":"钟宝镇","610927105":"上竹镇","610927106":"华坪镇","610927108":"曙坪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610927.json
// module id = 2669
// module chunks = 0